import { render, staticRenderFns } from "./TextWithSlider.vue?vue&type=template&id=5db142a2&scoped=true&"
import script from "./TextWithSlider.vue?vue&type=script&lang=js&"
export * from "./TextWithSlider.vue?vue&type=script&lang=js&"
import style0 from "./TextWithSlider.vue?vue&type=style&index=0&id=5db142a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db142a2",
  null
  
)

export default component.exports